import { render, staticRenderFns } from "./ViewOrderReferenceButton.vue?vue&type=template&id=2a9227b8&"
import script from "./ViewOrderReferenceButton.vue?vue&type=script&lang=js&"
export * from "./ViewOrderReferenceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports